import React from "react";
import isMobile from "ismobilejs";
import { connect } from "react-redux";

import { guardarDatosPersona } from "./flujo.act";
import { callService, formatPhone, formatDate, formatRamo, goTo } from "../tools";
import DatosForm from "./datos.frm.js";

const mapState = (state) => {
	console.log("aviso aceptado: " + state.registro.avisoAceptado);
	console.log("terminos aceptado: " + state.registro.mediosElectronicos);
	return {
		ramo: state.registro.ramo,
		poliza: state.registro.poliza,
		vigencia: state.registro.inicioVigenciaPolizaDate,
		certificado: state.registro.certificado,
		motor: state.registro.motor,
		placas: state.registro.placas,
		avisoAceptado: state.registro.avisoAceptado,
		mediosElectronicos: state.registro.mediosElectronicos
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		alerta: (sTitulo, sMensaje, fnClose) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": sTitulo, "mensaje": sMensaje, "accion": fnClose });
		},
		alertaCode: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo": sCode });
		},
		pasoSiguiente: () => {
			dispatch({ "type": "REGISTRO_PASO_SIGUIENTE" });
		},
		pasoAnterior: () => {
			dispatch({ "type": "REGISTRO_PASO_ANTERIOR" });
		},
		registrarDatos(sEmail, sfechaNacimiento, sfechaNacimientoDate, sLadaFijo, sTelefonoFijo, sLadaMovil, sTelefonoMovil, sApaterno, sAmaterno, sNombres, sRfc) {
			dispatch(guardarDatosPersona(sEmail, sfechaNacimiento, sfechaNacimientoDate, sLadaFijo, sTelefonoFijo, sLadaMovil, sTelefonoMovil, sApaterno, sAmaterno, sNombres, sRfc));
		}
	};
};

class Datos extends React.Component {

	getHerramienta = () => {
		return (isMobile.any == true) ? "APP" : "PORTAL";
	}

	submit = (data) => {
		let $this = this;
		let herramienta = this.getHerramienta();

		$this.props.loader(true);
		$this.props.registrarDatos(
			data.email,
			data.fecha_nacimiento,
			data.fecha_nacimiento_date,
			data.lada_fijo,
			data.telefono_fijo,
			data.lada_movil,
			data.telefono_movil,
			data.apaterno,
			data.amaterno,
			data.nombres,
			data.rfc
		);

		let llamaServicio = new callService({
			service: "registro.datosPersonales",
			secure: true,
			data: {
				ramo: formatRamo(this.props.ramo),
				poliza: this.props.poliza,
				certificado: this.props.certificado,
				vigencia: formatDate(this.props.vigencia),
				email: data.email,
				nacimientoFecha: formatDate(data.fecha_nacimiento_date),
				ladaFijo: formatPhone(data.lada_fijo),
				ladaMovil: formatPhone(data.lada_movil),
				telefonoFijo: data.telefono_fijo,
				telefonoMovil: data.telefono_movil,
				herramienta: herramienta,
				avisoAceptado: this.props.avisoAceptado,
				mediosElectronicos: this.props.mediosElectronicos,
				origenapp: 'POR_CL'
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta", respuesta);
			$this.props.loader(false);

			if (respuesta.registrarClienteResponse.banExito) {
				if (herramienta == "PORTAL") {
					goTo("registro-completo");
				}
				if (herramienta == "APP") {
					goTo(respuesta.url);
				}
				$this.props.pasoSiguiente();
			}
		}).catch((error) => {
			console.log("Error", error);
			$this.props.loader(false);

			if (error.message.codigoError == "REG005" || error.message.codigoError == "REG006") {
				goTo("gnp/registro-asistido");
			} else if (error.message.codigoError == "REG004") {
				$this.props.alerta("Importante", "No es posible registrarte con una póliza fuera de vigencia. Favor de verificarla.");
			} else {
				$this.props.alertaCode(error.message.codigoError);
			}
		});
	}

	render() {
		return (
			<DatosForm onSubmit={this.submit} />
		);
	}
}

export default connect(mapState, mapDispatch)(Datos);


// WEBPACK FOOTER //
// ./src/registro/datos.cmpt.js